var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(obj, key, value) {key = _toPropertyKey(key);if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);}import React from 'react';

import { get } from 'lodash';
import { ItemTypes } from "../../../shared/types";
import { TableRow } from "./TableRow";
import { withDnD, withDnDBackend } from "../../componentWrappers";
import { useDnDContext } from "../../Layouts/DragAndDrop";
















// eslint-disable-next-line comma-spacing
const setItemId = (item, parent, index) => _objectSpread(_objectSpread({},
item), {}, {
  dndId: parent ? `${parent.dndId}.${index}` : index.toString() });


const setRowId =



(subRowsKey, records, parent) =>
(records || []).
filter((f) => f).
map((item, index) => {
  const itemWithId = setItemId(item, parent, index);
  return _objectSpread(_objectSpread({},
  itemWithId),
  subRowsKey ?
  {
    [subRowsKey]: setRowId(subRowsKey, get(item, subRowsKey), itemWithId)
  } :
  {});

});

// eslint-disable-next-line comma-spacing
const TableBodyComponent = ({
  draggableRows,
  allowEditGroupsWithDnD,
  DndProvider,
  HTML5Backend,
  items,
  table,
  subRowsKey,
  onChange
}) => {
  const dndContext = useDnDContext(
    ItemTypes.ROW,
    {
      getDisplayName: (item) => item.dndId,
      itemsProperty: subRowsKey,
      onChange,
      allowEditGroupsWithDnD
    },
    items,
    []
  );

  return draggableRows && DndProvider && HTML5Backend ? /*#__PURE__*/
  _jsx("tbody", { "data-testid": "dnd_table_body" }, void 0, /*#__PURE__*/
  _jsx(DndProvider, { backend: HTML5Backend }, void 0,
  dndContext.activeItems.
  map((item) => {
    const itemValue = item.value;
    const row = table.getRowModel().rowsById[itemValue.dndId];
    const children =
    row && row.getIsExpanded() ?
    (item.value.items || []).
    filter((v) => v).
    map((subItem) => {
      const subItemValue = subItem.value;
      const childRow = table.getRowModel().rowsById[subItemValue.dndId];

      return childRow !== undefined ? /*#__PURE__*/
      _jsx(TableRow, {

        draggableRow: true,
        row: childRow,
        dndContext: dndContext,
        enableSelection: false,
        item: subItem }, subItem.dndId
      ) :

      childRow;

    }).
    filter((child) => child !== undefined) :
    [];
    return row !== undefined ? /*#__PURE__*/
    _jsx(React.Fragment, {}, item.dndId, /*#__PURE__*/
    _jsx(TableRow, {
      draggableRow: true,
      row: row,
      dndContext: dndContext,
      enableSelection: false,
      item: item }
    ),
    children
    ) :

    row;

  }).
  filter((row) => row !== undefined)
  )
  ) : /*#__PURE__*/

  _jsx("tbody", {}, void 0,
  table.getRowModel().rows.map((row) => /*#__PURE__*/
  _jsx(TableRow, { row: row, enableSelection: false }, row.id)
  )
  );

};

const typedMemo = React.memo;

const TableBody = (props) => {
  const tableBodyProps = _objectSpread(_objectSpread({}, props), {}, { items: setRowId(props.subRowsKey || 'items', props.items) });
  return withDnD(typedMemo(withDnDBackend(TableBodyComponent)))(tableBodyProps);
};

export { TableBody };